import * as React from 'react'
import {InquiryStatus} from '../Entities/InquiryStatus'
import Chip from 'material-ui/Chip'
import Avatar from 'material-ui/Avatar'
import ContentReply from 'material-ui/svg-icons/content/reply'
import {
    blueGrey500,
    blueGrey800,
    deepOrange700,
    deepOrange900,
    green600,
    green800,
    lightGreen400,
    lightGreen800,
    lime500,
    lime800
} from 'material-ui/styles/colors'
import ActionCached from 'material-ui/svg-icons/action/cached'
import ActionDone from 'material-ui/svg-icons/action/done'
import ContentClear from 'material-ui/svg-icons/content/clear'
import ActionDelete from 'material-ui/svg-icons/action/delete'
import ActionDoneAll from 'material-ui/svg-icons/action/done-all'
import ContentBlock from 'material-ui/svg-icons/content/block'
import injectSheet from 'react-jss'

const styles = {
    flex: {
        display: 'flex',
    }
}

interface Props {
    readonly inquiryStatus: InquiryStatus
}

export const PrintStatus =
    injectSheet<Props>(styles)(
        ({classes, inquiryStatus}) => {
            return (
                <div className={classes.flex}>
                    {(() => {
                        switch (inquiryStatus) {
                            case 'requested':
                                return (
                                    <Chip
                                        backgroundColor="#448AFF"
                                        labelColor="#fff"
                                    >
                                        <Avatar
                                            icon={<ContentReply/>}
                                            backgroundColor="#2962FF"
                                        />
                                        Angefordert
                                    </Chip>
                                )
                            case 'inApproval':
                                return (
                                    <Chip backgroundColor={lime500}>
                                        <Avatar
                                            icon={<ActionCached/>}
                                            backgroundColor={lime800}
                                        />
                                        In Freigabe
                                    </Chip>
                                )
                            case 'approved':
                                return (
                                    <Chip
                                        backgroundColor={green600}
                                        labelColor="#fff"
                                    >
                                        <Avatar
                                            icon={<ActionDone/>}
                                            backgroundColor={green800}
                                        />
                                        Freigegeben
                                    </Chip>
                                )
                            case 'rejected':
                                return (
                                    <Chip
                                        backgroundColor={deepOrange700}
                                        labelColor="#fff"
                                    >
                                        <Avatar
                                            icon={<ContentClear/>}
                                            backgroundColor={deepOrange900}
                                        />
                                        Abgelehnt
                                    </Chip>
                                )
                            case 'discarded':
                                return (
                                    <Chip
                                        backgroundColor={blueGrey500}
                                        labelColor="#fff"
                                    >
                                        <Avatar
                                            icon={<ActionDelete/>}
                                            backgroundColor={blueGrey800}
                                        />
                                        Verworfen
                                    </Chip>
                                )
                            case 'finished':
                                return (
                                    <Chip backgroundColor={lightGreen400}>
                                        <Avatar
                                            icon={<ActionDoneAll/>}
                                            backgroundColor={lightGreen800}
                                        />
                                        Abgeschlossen
                                    </Chip>
                                )
                            case 'notRequired':
                                return (
                                    <Chip>
                                        <Avatar icon={<ContentBlock/>}/>
                                        Nicht benötigt
                                    </Chip>
                                )
                        }
                    })()}
                </div>
            )
        }
    )



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/View/InquiryStatusDisplay.tsx